import i18n from "i18next";
import { useTranslation as translation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  changeLang,
  getLotsOfCountryAndProfessionType,
} from "../redux/actions/authActions";
import { configDefaultDateFormat } from "../redux/actions/configActions";
import { DefaultDateFormat } from "../redux/actions/types/configTypes";
import BundleKey from "../translation/bundleKey";
import { useStore } from "./useStore";

export const useTranslation = () => {
  const { t } = translation();
  const dispatch = useDispatch();
  const { authStore } = useStore();

  const changeLanguage = (value: string) => {
    dispatch(changeLang(value));
    i18n.changeLanguage(value);
    dispatch(
      configDefaultDateFormat(
        value === "en_US"
          ? DefaultDateFormat.english
          : DefaultDateFormat.default
      )
    );
    getLotsOfCountryAndProfessionType(authStore.token, dispatch, value);
  };

  return { t, BundleKey, changeLanguage, language: authStore.lang };
};
